const $ = jQuery.noConflict();

'use strict';
const StepsAnimation = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.animations();

	},

	animations: function() {
		function animationFirst() {
			const step1 = $('.js-step-1');
			const step2 = $('.js-step-2');
			step1.addClass('active').delay(5000).queue(function(next) {
				$(this).removeClass('active').addClass('show');
				step2.addClass('active');
				next();
			}).delay(5000).queue(function(next) {
				$(this).removeClass('show');
				step2.removeClass('active');
				$(this).dequeue();
				setTimeout(animationFirst, 0);
				next();
			});
		}
		animationFirst();
	},
};

export default StepsAnimation;
